export default __webpack_public_path__ + "static/media/HPSimplified_W_Bd.dd9f9956.woff";